/**
 * Configuration for ATM Management Frontend
 * 
 * In development: Worker runs on localhost:8787
 * In production: Set REACT_APP_API_URL to your Worker URL (e.g., https://atm-api.yourdomain.workers.dev)
 */

// API Base URL - Worker is a separate service
export const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://atm-api.yourdomain.workers.dev/api/v1'  // Update this for production
    : 'http://localhost:8787/api/v1');  // Worker dev port

export const config = {
  apiBaseUrl: API_BASE_URL,
  tokenKey: 'atm_auth_token',
  userKey: 'atm_user_data'
};

